export default __webpack_public_path__ + "static/media/81.668dd680.jpg";